const CHECKOUT_SUCCESS_STORAGE_KEY = 'mizfa:pricing:checkoutSuccess';

type CheckoutSuccessMode = 'default' | 'member';

export function reloadAfterCheckoutSuccess(isMemberStep = false): void {
  sessionStorage.setItem(
    CHECKOUT_SUCCESS_STORAGE_KEY,
    isMemberStep ? 'member' : 'default',
  );
  window.location.reload();
}

export function consumeCheckoutSuccessReload(): CheckoutSuccessMode | null {
  const value = sessionStorage.getItem(CHECKOUT_SUCCESS_STORAGE_KEY);
  if (!value) return null;

  sessionStorage.removeItem(CHECKOUT_SUCCESS_STORAGE_KEY);
  return value === 'member' ? 'member' : 'default';
}
